import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { browserHelpers } from 'utils'
import {
  PlayArrowFilled,
  Download,
  Info
} from '@dsny/dsny-component-library/icons'
import PlaceholderLogo from 'images/icons/placeholder.png'
import {
  TrackSearchCardContainer,
  ImageContainer,
  TrackSearchCardImage,
  ActionBarAbsoluteContainer,
  ActionBar,
  ActionButton,
  TextContainer
} from './TrackSearchCard.styles'
import Tooltip from 'components/Tooltip'

export default function TrackSearchCard({
  track,
  onShowModal,
  handlePlayTrack,
  handleDownloadTrack
}) {
  const theme = useTheme()
  const navigate = useNavigate()
  const isMobile = useMobileMediaQuery()

  const onPlayTrack = (e) => {
    e.stopPropagation()
    handlePlayTrack(track)
  }

  const onDownloadTrack = (e) => {
    e.stopPropagation()
    handleDownloadTrack(track)
  }

  const onInfoTrackClick = (e) => {
    e.stopPropagation()
    navigate(`/releases/releaseInfo/${track.releaseid}`)
  }

  const onTrackClick = () => {
    if (isMobile) {
      navigate(`/releases/releaseInfo/${track.releaseid}`)
    } else {
      onShowModal(track)
    }
  }

  return (
    <TrackSearchCardContainer onClick={onTrackClick}>
      <ImageContainer>
        <TrackSearchCardImage
          src={track?.coverart || PlaceholderLogo}
          alt="track cover"
        />

        {!isMobile && (
          <ActionBarAbsoluteContainer className="action_bar">
            <ActionBar>
              <Tooltip hasArrow={false} placement="top" text="Play track">
                <ActionButton
                  variant="primary"
                  setting="player"
                  mode="dark"
                  onClick={onPlayTrack}
                >
                  <PlayArrowFilled
                    width={16}
                    height={16}
                    color={theme.colors.black0}
                  />
                </ActionButton>
              </Tooltip>

              {browserHelpers.browserAllowsDownload && track?.candownload && (
                <Tooltip
                  hasArrow={false}
                  placement="top"
                  text="Download track"
                >
                  <ActionButton
                    variant="primary"
                    setting="player"
                    mode="dark"
                    onClick={onDownloadTrack}
                  >
                    <Download
                      width={16}
                      height={16}
                      color={theme.colors.black0}
                    />
                  </ActionButton>
                </Tooltip>
              )}

              <Tooltip hasArrow={false} placement="top" text="Track info">
                <ActionButton
                  variant="primary"
                  setting="player"
                  mode="dark"
                  onClick={onInfoTrackClick}
                >
                  <Info width={16} height={16} color={theme.colors.black0} />
                </ActionButton>
              </Tooltip>
            </ActionBar>
          </ActionBarAbsoluteContainer>
        )}
      </ImageContainer>

      <TextContainer>
        <Tonality.UIText
          textStyle="bodyBold"
          color={theme.colors.neutralW100}
          className="truncate"
        >
          {track?.title}
        </Tonality.UIText>
        <Tonality.UIText
          textStyle="body"
          color={theme.colors.neutralW70}
          className="truncate"
        >
          {track?.artist}
        </Tonality.UIText>
      </TextContainer>
    </TrackSearchCardContainer>
  )
}

TrackSearchCard.propTypes = {
  track: PropTypes.shape({
    releaseid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    artist: PropTypes.string,
    coverart: PropTypes.string,
    candownload: PropTypes.bool
  }).isRequired,
  onShowModal: PropTypes.func.isRequired,
  handlePlayTrack: PropTypes.func.isRequired,
  handleDownloadTrack: PropTypes.func.isRequired
}
